export const BRAND = {
  name: "Bawajii Travels & Infra",
  short: "Bawajii",
  tagline: "Your journey, our promise.",
  whatsapp: "919712212264",
  phone: "+91 97122 12264",
  email: "bawajiitravelsandinfra@gmail.com",
  address: "402, Soham Arcade, Bagban Circle, Pal Gauravpath Road, Pal, Surat-395004",
};

export const buildWhatsAppLink = (message) => {
  const num = BRAND.whatsapp.replace(/\D/g, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(message)}`;
};
